<div class="main-container">
    <div class="modal-header">
        <div class="checkin-and-phase-container">
            <span>{{data.checkinTitle}}</span>
            <div [ngStyle]="{'background-color':data.phaseColor}" class="phase-container">
                <span>{{data.phaseTitle}}</span>
            </div>
        </div>
        <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="close(null);$event.stopPropagation()">
    </div>
    <div class="modal-body">
        <span class="note-title-question">{{data.formData.questionTitleKey | translate}}</span>
        <div class="d-flex flex-column gap-2">
            <div class="note-text-input-container">
                <textarea
                    #textarea
                    class="note-text-input" 
                    [(ngModel)]="noteText"
                    maxlength="300"
                    [readOnly]="data.editMode && !isEditing" 
                    [placeholder]="data.editMode ? '' : (data.formData.questionPlaceholderKey | translate)">
                </textarea>
                <span *ngIf="data.editMode" class="note-text-input-edit-btn" (click)="toggleEditMode()">{{ !isEditing ? (data.formData.questionEditBtnKey | translate) : 'Cancel'}}</span>
            </div>
            <span *ngIf="noteText.length >= 300" class="note-text-counter">Maximum 300 characters</span>
            <span *ngIf="noteText.length < 300" class="note-text-counter">{{noteText.length}}/300</span>
        </div>
        <button class="save-note-btn" pButton
            (click)="saveNote()"
            [disabled]="isSaveDisabled()" 
            [label]="(data.formData.questionSaveBtnKey | translate)"></button>
    </div>
</div>